import { useEffect, useState } from 'react';

const ASCIIBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const asciiArt = `
  ██╗███╗   ██╗████████╗███████╗██████╗ ███╗   ██╗███████╗████████╗
  ██║████╗  ██║╚══██╔══╝██╔════╝██╔══██╗████╗  ██║██╔════╝╚══██╔══╝
  ██║██╔██╗ ██║   ██║   █████╗  ██████╔╝██╔██╗ ██║█████╗     ██║   
  ██║██║╚██╗██║   ██║   ██╔══╝  ██╔══██╗██║╚██╗██║██╔══╝     ██║   
  ██║██║ ╚████║   ██║   ███████╗██║  ██║██║ ╚████║███████╗   ██║   
  ╚═╝╚═╝  ╚═══╝   ╚═╝   ╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚══════╝   ╚═╝   
                                                                    
   ██████╗  █████╗ ███╗   ██╗ ██████╗ ███████╗████████╗███████╗██████╗ 
  ██╔════╝ ██╔══██╗████╗  ██║██╔════╝ ██╔════╝╚══██╔══╝██╔════╝██╔══██╗
  ██║  ███╗███████║██╔██╗ ██║██║  ███╗███████╗   ██║   █████╗  ██████╔╝
  ██║   ██║██╔══██║██║╚██╗██║██║   ██║╚════██║   ██║   ██╔══╝  ██╔══██╗
  ╚██████╔╝██║  ██║██║ ╚████║╚██████╔╝███████║   ██║   ███████╗██║  ██║
   ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝   ╚═╝   ╚══════╝╚═╝  ╚═╝
  `;

  return (
    <div 
      className={`font-mono text-[hsl(var(--neon-green))] text-[10px] leading-tight whitespace-pre transition-opacity duration-1000 ${visible ? 'opacity-100' : 'opacity-0'}`}
      style={{ textShadow: '0 0 10px hsl(var(--neon-green))' }}
      data-testid="ascii-banner"
    >
      {asciiArt}
    </div>
  );
};

export default ASCIIBanner;
